import { useMemo } from 'react';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';

/**
 * Whether this visitor is enrolled in the hardware-first checkout. The 'hardware-first-checkout'
 * feature is read truthily so the legacy string variant ('launch-30') and the boolean feature that
 * replaces it both enrol; empty, false, or absent means control. All pricing comes from the server.
 */
export default function useHardwareFirstCheckout(): boolean {
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  return useMemo(() => {
    if (!isGrowthBookEnabled) {
      return false;
    }
    return !!getFiGrowthBook().getFeatureValue<boolean | string>('hardware-first-checkout', false);
  }, [isGrowthBookEnabled]);
}
